'use client';
import cn from 'classnames';
import styles from './SortDropdown.module.scss';
import { useRef, useState, useEffect } from 'react';
import { SortFilterType } from '@/types';

type SortDropdownProps = {
  className?: string;
  onChange: (value: SortFilterType) => void;
  value: SortFilterType;
  variants: SortFilterType[];
};

export function SortDropdown({
  className,
  onChange,
  value,
  variants,
}: SortDropdownProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [showList, setShowList] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current.contains(event.target as Node)
      ) {
        hideContent();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClickTrigger = () => {
    setShowList((prev) => !prev);
  };

  const hideContent = () => {
    setShowList(false);
  };

  const handleClickItem = (variant: SortFilterType) => {
    onChange(variant);
    hideContent();
  };

  return (
    <div className={wrapperClassName} ref={contentRef}>
      <div className={styles.trigger} onClick={handleClickTrigger}>
        <div className={styles.text}>
          Сначала <span className={styles.highlight}>{value.name}</span>
        </div>
        <img
          src="/svg/chevron-black.svg"
          alt="arrow"
          className={cn(styles.icon, {
            [styles.rotate]: showList,
          })}
        />
      </div>
      {showList && (
        <div className={styles.list}>
          {variants.map((variant) => (
            <div
              key={variant.code}
              className={styles.item}
              onClick={() => handleClickItem(variant)}
            >
              <span className={styles.itemText}>{variant.name}</span>
              {variant.code === value.code && (
                <img
                  src="/svg/check.svg"
                  alt="check"
                  className={styles.check}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
